import { useQuery } from 'react-apollo';
import Product3D from './Product3D.gql';

const GetProduct = (articleNumber) => {
  const { data, loading, error } = useQuery(Product3D, {
    variables: {
      articleNumber: articleNumber,
      days: 30
    },
  });

  if (loading || error) return null;

  return data.product
}
export default GetProduct;